import { type ReactNode, useRef } from 'react'
import { useTheme } from 'styled-components'

import { ListingsCarousel } from '@/components/shared/listings-carousel/ListingsCarousel'
import { HeadlineText } from '@/ui/atoms/headline-text'
import { Spacing } from '@/ui/atoms/spacing'
import { type ResponsiveProp } from '@/ui/typings/helpers'

type BRPCarouselLayoutProps = {
  title: string
  carouselName: string
  slides: ReactNode[]
  slidesToShow?: ResponsiveProp<number>
  shouldShowArrows?: ResponsiveProp<boolean>
  slideCustomStyle?: string
}

export const BRPCarouselLayout = ({
  title,
  carouselName,
  slides,
  slidesToShow = { small: 3, medium: 6, large: 8 },
  shouldShowArrows = { small: false, medium: false, large: true },
  slideCustomStyle,
}: BRPCarouselLayoutProps) => {
  const { spacing } = useTheme()
  const listRef = useRef(null)

  return (
    <Spacing mBottom={spacing.mini}>
      <Spacing mBottom={spacing.large}>
        <HeadlineText as="h3" size="xLarge">
          {title}
        </HeadlineText>
      </Spacing>
      <ListingsCarousel
        enableImpressionsTracking
        name={carouselName}
        slides={slides}
        slidesToShow={slidesToShow}
        shouldShowArrows={shouldShowArrows}
        slideCustomStyle={slideCustomStyle}
        listCustomProps={{ ref: listRef, style: { padding: 0 } }}
      />
    </Spacing>
  )
}
